import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { RoomsComponent } from './rooms/rooms.component';
import { SchedulesComponent } from './schedules/schedules.component';
import { BuyComponent } from './buy/buy.component';
import { SettingsComponent } from './settings/settings.component';
import { ClickOutsideDirective } from './click-outside.directive';

import {HashLocationStrategy, Location, LocationStrategy} from '@angular/common';
import { ViewRoomComponent } from './view-room/view-room.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    RoomsComponent,
    SchedulesComponent,
    BuyComponent,
    SettingsComponent,
    ClickOutsideDirective,
    ViewRoomComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
